import { useCallback } from 'react';

import { Button, Flex, Modal, Text } from 'ui';

import { useLogoutUser } from '../../../hooks/useLogoutUser';
import Native from '../../../utils/native';

type LogoutConfirmationProps = {
  visibility: boolean;
  handleClose: () => void;
};

export default function LogoutConfirmation(props: LogoutConfirmationProps) {
  const { visibility, handleClose } = props;
  const { userLogout } = useLogoutUser();

  const handleLogout = useCallback(() => {
    if (Native.WebView) {
      Native.postMessage('Logout');
    } else {
      void userLogout({ callBack: handleClose });
    }
  }, [handleClose, userLogout]);

  return (
    <Modal title="Confirm Logout" opened={visibility} onClose={handleClose}>
      <Text c="gray.6" fz="18" fw="400">
        Are you sure you want to log out?
      </Text>
      <Flex gap="md" pt="lg" justify="center">
        <Button onClick={handleClose} fullWidth variant="subtle">
          Cancel
        </Button>
        <Button color="cerise" onClick={handleLogout} fullWidth>
          Log Out
        </Button>
      </Flex>
    </Modal>
  );
}
